export default function (campaign) {
  const {
    businesstype,
    sellingOnline,
    namecomputed,
    business_area,
    legacyexf,
    legacyexp,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    alwaysOn,
    brands,
    ccCallsEndDate,
    ccCallsStartDate,
    ccExtractionDaysFreq,
    ccMaxRecordsToExtract,
    ccScript,
    ccdbReportEnabled,
    ccdbReportType,
    config,
    cscEngagementLevel,
    description,
    endDate,
    finality,
    jeepWave,
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    ppExtractionDaysFreq,
    ppExtractionEndDate,
    ppExtractionStartDate,
    ppMaxRecordsToExtract,
    ppProviderId,
    ppTemplateFilename,
    ppUrl1,
    ppUrl2,
    ppUrl3,
    recordType,
    segmentType,
    startDate,
    status,
    type
  } = campaign

  return {
    businesstype,
    sellingOnline,
    namecomputed,
    business_area,
    legacyexf,
    legacyexp,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    alwaysOn,
    brands,
    ccCallsEndDate: ccCallsEndDate || null,
    ccCallsStartDate: ccCallsStartDate || null,
    ccExtractionDaysFreq,
    ccMaxRecordsToExtract,
    ccScript: ccScript || null,
    ccdbReportEnabled,
    ccdbReportType,
    config,
    cscEngagementLevel,
    description,
    endDate: endDate || null,
    finality,
    jeepWave: jeepWave || [],
    manager,
    marketCodes: Array.isArray(marketCodes) ? marketCodes : [marketCodes],
    masterKey,
    name,
    onlyHeader,
    ppExtractionDaysFreq,
    ppExtractionEndDate: ppExtractionEndDate || null,
    ppExtractionStartDate: ppExtractionStartDate || null,
    ppMaxRecordsToExtract,
    ppProviderId,
    ppTemplateFilename,
    ppUrl1,
    ppUrl2,
    ppUrl3,
    recordType,
    segmentType,
    startDate: startDate || null,
    status,
    type
  }
}
